<template>
    <div class="cities-page">
        <div class="container-fluid">
            <h1>Miasta zatwierdzone</h1>
            <div class="d-flex justify-content-between mt-3">
                <b-pagination v-if="totalRows>perPage" 
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                ></b-pagination>
            </div>
            <font-awesome-icon v-if="isLoading" :icon="['fas', 'spinner']" class="fa-spin buttonFaSpin" />
            <b-table v-else :items="myDataProvider" :fields="fields" :filter="filter" :show-empty="true"
                    class="mt-2" striped  outlined sort-icon-left empty-filtered-text="Nie znaleziono" empty-text="Brak danych"
                    :current-page="currentPage" :per-page="perPage"
                    sort-by="id"
                    :sort-desc="true"
                >
            </b-table>
            
        </div>
    </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers.common['Accept'] = 'application/json';

export default {
    name: 'adminCities',
    data() {
        return {
            isLoading: false,
            filter: [],
            perPage: 25,
            currentPage: 1,
            totalRows: 0,
            fields: [
                { label: 'Id', key: 'id', sortable: true },
                { label: 'Nazwa', key: 'city', sortable: true },
                { label: 'Kod pocztowy', key: 'postcode', sortable: true }
            ]
        }
    },
    computed: {
    },
    methods: {
        myDataProvider(ctx) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters['auth/token'];
            const promise = axios.post('/admin/cities_supported', {
                "perPage": ctx.perPage,
                "currentPage": ctx.currentPage,
                "sortBy": ctx.sortBy,
                "asc": ctx.sortDesc ? false : true,
                "filter": []
            });

            return promise.then(result => {
                const items = result.data.routes;
                this.totalRows = result.data.count || 0;
                return items || []
            })
        }
    }
}
</script>
